module.exports = "/_next/static/images/DiscoverAndActivate@2x-d248092f60758e3bce19433f56d339dd.png";